import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioWhaleTail
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

import IconRocket from '../../assets/images/backoffice/willyImages/rocket.png';
import IconCoins from '../../assets/images/backoffice/willyImages/coins.png';
import IconPeople from '../../assets/images/backoffice/willyImages/people.png';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD, walletsNFTWithdraw } from '../../helpers/helperFunctions';
import {
  getMyHubsBigWhale,
  getWiliCoinsSummary,
  updateWillyCoinsSummary
} from './Portfolio.actions';

import { BIG_WHALE, MY_TEAM } from '../../routes/routes';
import { PortfolioBigWhaleItem } from './PortfolioBigWhaleItem';
import Spinner from '../../components/common/Spinner';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { PackageTrading, UserPackage } from './Portfolio.types';

interface BigWhaleSummaryProps {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  withdrawStep: WithdrawStepsEnum;
}
export const BigWhaleSummary = ({
  withdrawStep,
  setWithdrawStep
}: BigWhaleSummaryProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('my_hubs');
  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const [packageItem, setPackageItem] = useState<UserPackage | null>(null);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [selectedNFTWallet, setSelectedNFTWallet] = useState<any>(
    walletsNFTWithdraw[0]
  );

  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { bigWhale, loadingSummary, summary } = useAppSelector(
    (state) => state.portfolio
  );

  const { transferAssetStatus } = useAppSelector((state) => state.marketplace);

  const { isCanadaRestrictedUser, canBuyBigWhale, user } = useAppSelector(
    (state) => state.auth.userInfo
  );

  useEffect(() => {
    dispatch(getMyHubsBigWhale());
    dispatch(getWiliCoinsSummary());
  }, [dispatch]);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight);

    if (!loadingSummary && summary?.changePeriodInSeconds != undefined) {
      const interval = setInterval(() => {
        dispatch(updateWillyCoinsSummary(summary));
      }, summary?.changePeriodInSeconds * 1000);

      return () => clearInterval(interval);
    }
  }, [bigWhale, summary]);

  return (
    <>
      <div style={{ marginBottom: 40 }}>
        <Flexed mb='20' center between>
          <H3>My BigWhale Package summary</H3>
        </Flexed>

        <SummaryGrid>
          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioOrders />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                Total BigWhale Orders
              </CaptionText>

              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(bigWhale?.summary?.totalOrderAmount)}
                <P3 mb='1'>USDT</P3>
              </P1>
            </div>
          </BoxPortfolio>

          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioWhaleTail />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                BigWhale Points
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                <>
                  {formatUSD(
                    Number(bigWhale?.summary?.totalBigWhalePoints) || 0
                  )}{' '}
                  <P3 mb='1'>BP</P3>
                </>
              </P1>
            </div>
          </BoxPortfolio>
        </SummaryGrid>

        <div style={{ position: 'relative' }}>
          {loadingSummary && <Spinner absolute transparent />}

          <SummaryGrid>
            <BoxPortfolio>
              <img
                src={IconCoins}
                alt=''
                style={{ width: 45, marginRight: 20 }}
              />
              <div>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  TOTAL WILLY MEME COIN COLLECTION
                </CaptionText>

                <P1 bold flex alignEnd gap='5px'>
                  {formatUSD(summary?.totalMemeCoins)}
                  <P3 mb='1'>WILLY</P3>
                </P1>
              </div>
            </BoxPortfolio>

            <BoxPortfolio>
              <img
                src={IconRocket}
                alt=''
                style={{ width: 60, marginRight: 10 }}
              />
              <div>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  WILLY COLLECTED FROM BIGWHALE STRATEGY
                </CaptionText>
                <Flexed between gap='10px'>
                  <P1 bold flex alignEnd gap='5px'>
                    <>
                      {formatUSD(summary?.memeCoinsFromBigWhale)}
                      <P3 mb='1'>WILLY</P3>
                    </>
                  </P1>

                  {summary?.memeCoinsFromBigWhale === 0 && (
                    <a
                      href={`${process.env.REACT_APP_FINUP_URL}?userId=${user.id}`}
                      target='_blank'
                      rel='noreferrer'>
                      <Button h='34px'>Deposit into FinUp</Button>
                    </a>
                  )}
                </Flexed>
              </div>
            </BoxPortfolio>

            <BoxPortfolio>
              <img
                src={IconPeople}
                alt=''
                style={{ width: 45, marginRight: 20 }}
              />

              <div>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  WILLY COLLECTED FROM "BRING 3 PROMOTION"
                </CaptionText>
                <Flexed between gap='10px'>
                  <P1 bold flex alignEnd gap='5px'>
                    <>
                      {formatUSD(summary?.memeCoinsFromBring3)}

                      <P3 mb='1'>WILLY</P3>
                    </>
                  </P1>

                  {summary?.memeCoinsFromBring3 === 0 && (
                    <Button h='34px' onClick={() => history.push(MY_TEAM)}>
                      Start with promotion
                    </Button>
                  )}
                </Flexed>
              </div>
            </BoxPortfolio>
          </SummaryGrid>
        </div>

        <Flexed center between wrap>
          <Flexed
            mb='20'
            center
            gap='20px'
            pointer
            onClick={() => setExpanded(!expanded)}>
            <H4>My BigWhale Packages</H4>
            <ArrowChevron direction={expanded ? 'up' : 'down'} />
          </Flexed>
          {!isCanadaRestrictedUser && canBuyBigWhale && (
            <Button
              negative
              maxWidth='350px'
              maxWidthSM='100%'
              onClick={() => history.push(BIG_WHALE)}>
              ADD BIGWHALE PACKAGE
            </Button>
          )}
        </Flexed>

        <Collapsable expanded={expanded} elementHeight={height}>
          <div ref={ref}>
            {bigWhale?.userPackages?.map((item: any, i: number) => (
              <PortfolioBigWhaleItem
                key={i}
                item={item}
                setPackageItem={setPackageItem}
                setSelectedNFTWallet={setSelectedNFTWallet}
                withdrawModal={withdrawModal}
                setWithdrawModal={setWithdrawModal}
                transferAssetStatus={transferAssetStatus}
              />
            ))}
          </div>
        </Collapsable>
      </div>

      {packageItem && (
        <WithdrawHubs
          openModal={withdrawModal}
          setOpenModal={setWithdrawModal}
          packageId={packageItem.id}
          withdrawStep={withdrawStep}
          setWithdrawStep={setWithdrawStep}
          item={packageItem}
          selectedNFTWallet={selectedNFTWallet}
          setSelectedNFTWallet={setSelectedNFTWallet}
        />
      )}
    </>
  );
};
